import { clearCustomerSession } from "api";
import { IReward } from "api/types";
import Button from "components/common/Button/Button";
import LabelStat from "components/common/LabelStat";
import * as React from "react";
import { ApolloConsumer } from "react-apollo";
import { Col, Row } from "react-grid-system";
import { Link } from "react-router-dom";
import styled from "styled-components";
import theme from "themes/simple-theme";
import RewardsList from "../RedeemConfirmation/RewardsList";

interface IProps {
  total: number;
  rewards: IReward[];
  quantity?: number;
  tenantId?: string;
  locationId?: string;
  rewardImageBaseUrl?: string;
  onDone?(): void;
}

const OrderSummary = ({
  rewards,
  total,
  tenantId,
  locationId,
  rewardImageBaseUrl,
  onDone
}: IProps) => (
  <React.Fragment>
    <ListHeading>Rewards Summary</ListHeading>
    <RewardsList
      rewards={rewards}
      tenantId={tenantId}
      locationId={locationId}
      imageBaseUrl={rewardImageBaseUrl}
      transparentBackground
    />
    <Row align="start">
      <Col align="end">
        <TotalPoints black label="Total Points:" value={total} />
      </Col>
    </Row>
    <Row align="end">
      <Col align="end">
        <Link to="/">
          <Button onClick={onDone} primary wide>
            I'm Done
          </Button>
        </Link>
      </Col>
    </Row>
  </React.Fragment>
);

const TotalPoints = styled(LabelStat)`
  margin-top: 30px;
  margin-bottom: 50px;
  color: ${theme.color.primary};
  font-family: ${theme.fontFamily.bold};
`;

const ListHeading = styled.p`
  font-size: 14px;
  padding-bottom: 10px;
  text-transform: uppercase;
  text-align: center;
  margin-left: -15px;
  margin-right: -15px;
  border-bottom: 1px solid ${theme.color.primary};
  font-family: ${theme.fontFamily.bold};
  color: ${theme.color.primary};
`;

export default (props: IProps) => (
  <ApolloConsumer>
    {client => {
      const onDone = () => clearCustomerSession(client);
      return <OrderSummary onDone={onDone} {...props} />;
    }}
  </ApolloConsumer>
);



// WEBPACK FOOTER //
// ./src/screens/RedeemRewards/RedeemCompelte/OrderSummary.tsx